













































































import { Component, Mixins } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import DomainPoolData from '@/data/DomainPoolData';
import DomainPoolBody from '@/components/Table/DomainPoolBody.vue';
import { getModule } from 'vuex-module-decorators';
import DomainPoolModule from '@/store/modules/DomainPool';
import GeneralModule from '@/store/modules/General';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import { IDomainPoolAdd, IDomainPoolList, IDomainPoolUpdate } from '@/interface/DomainPool';

@Component({
  components: {
    DomainPoolBody,
    Table,
  },
})
export default class DomainPool extends Mixins(ToolMixin, ErrorHandleMixin) {
  // Data and properties
  TableHeadDomainPool = DomainPoolData.TableHeadDomainPool;

  typeList: string[] = ['all'];

  typeListModal: string[] = [];

  dataList: IDomainPoolList[] = [];

  filteredDataList: IDomainPoolList[] = [];

  selectedType = 'all';

  addDomain: IDomainPoolAdd = { url: '', isActive: false, type: '' };

  showModal = false;

  DomainPoolInstance = getModule(DomainPoolModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  // Lifecycle hook
  created() {
    this.fetchDomainPoolList();
  }

  // Fetch domain list
  async fetchDomainPoolList() {
    this.clearCache();
    await this.GeneralInstance.toggleLoading(true);
    const { data, status } = await this.DomainPoolInstance.FetchDomainList();
    await this.checkError(status);
    this.typeListModal = data.typeList;
    this.typeList = [...new Set(['all', ...data.typeList])];
    this.dataList = data.domainPoolList;
    this.filteredDataList = this.dataList;

    await this.GeneralInstance.toggleLoading(false);
  }

  // Filter domain list based on selected type
  filterDomainList() {
    this.filteredDataList = this.selectedType === 'all'
      ? this.dataList
      : this.dataList.filter((item) => item.type === this.selectedType);
    this.filteredDataList = [...new Set(this.filteredDataList)];
  }

  // Format type name (capitalize first letter)
  formatType(type: string): string {
    return type ? type.charAt(0).toUpperCase() + type.slice(1) : '';
  }

  // Handle modal opening
  openModal() {
    this.showModal = true;
  }

  // Handle modal closing
  closeModal() {
    this.showModal = false;
  }

  // Submit new domain
  async submitDomain() {
    if (this.addDomain.url && this.addDomain.type) {
      const { status } = await this.DomainPoolInstance.AddDomainList(this.addDomain);
      if (status.code) return this.checkError(status);

      await this.fetchDomainPoolList();
      this.closeModal();
    }
  }

  // Toggle domain active state
  async switchActive(data: IDomainPoolUpdate) {
    const params: IDomainPoolUpdate = { _id: data._id, isActive: !data.isActive, type: data.type };
    const { status } = await this.DomainPoolInstance.UpdateDomainList(params);
    if (status.code) return this.checkError(status);

    await this.fetchDomainPoolList();
  }

  // Clear cache and reset values
  clearCache() {
    this.dataList = [];
    this.filteredDataList = [];
    this.typeList = ['all'];
    this.selectedType = 'all';
    this.addDomain = { url: '', isActive: false, type: '' };
  }
}
